import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Message} from "primeng/primeng";
import {Configuracion} from "./configuracion";
import {ConfiguracionService} from "../Services/configuracion.service";
import {ActivatedRoute} from "@angular/router";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";


@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.css']
})
export class ConfiguracionComponent implements OnInit {

  msgs: Message[] = [];
  formConfiguracion : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  ConfiguracionRegistrados:Configuracion[];
  ConfiguracionSeleccionado:Configuracion;
  tipoGuardado = '';
  tiendaId;
  TiendasRegistrados:Tienda[];


  constructor(private servicioConfiguracion:ConfiguracionService,
              private fb: FormBuilder,
              private route: ActivatedRoute,
              private servicioTienda:TiendaService) { }

  ngOnInit() {
    this.crearControlesConfiguracion();
    this.obtenerParmTiendaId();
    this.listarConfiguracions();
    this.listarTiendas();
    this.Cancelar();
  }

  crearControlesConfiguracion(){
    this.formConfiguracion = this.fb.group({
      FacturaInicial:['',Validators.required],
      FacturaFinal:['',Validators.required],
      montoDiario:[''],
      activar:[''],
      tienda:[''],
      }
    );
  }
  nuevoConfiguracion(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formConfiguracion.enable();
    this.formConfiguracion.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formConfiguracion.reset();
    this.formConfiguracion.disable();
    this.panelRequeridos = false;
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoConfiguracion(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioConfiguracion.putConfiguracion(this.formConfiguracion.value,this.ConfiguracionSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarConfiguracions();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioConfiguracion.addConfiguracion(this.formConfiguracion.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarConfiguracions();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarConfiguracions(){
    this.loading = true;
    this.servicioConfiguracion.getConfiguracionById(this.tiendaId)
      .subscribe(
        rt => {
          this.ConfiguracionRegistrados = rt;

          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarConfiguracion(item:Configuracion){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formConfiguracion.enable();
    this.panelRequeridos = true;
    this.ConfiguracionSeleccionado = item;
    this.ConfiguracionDetalle(item);
    this.tipoGuardado = 'editar';
  }
  ConfiguracionDetalle(item:Configuracion):void {
    this.formConfiguracion.patchValue({
      id:item.id,
      FacturaInicial:item.FacturaInicial,
      FacturaFinal:item.FacturaFinal,
    });
  }
  obtenerParmTiendaId(){
    this.route.params
      .subscribe(params => {
        const _id = params['id'].toString();
        this.tiendaId = _id;
      });
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/configuracion/configuracion.component.ts